/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { cn } from "@farmlands/shadcn-ui";
import { ReactNode } from "react";

import { HEADER_BUTTON_STATE_CLASSES } from "./styles";

type HeaderIconButtonProps = {
  icon: ReactNode;
  count: number;
  ariaLabel: string;
  testId: string;
  onClick: () => void;
};

export const HeaderIconButton = ({
  icon,
  count,
  ariaLabel,
  testId,
  onClick,
}: HeaderIconButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    aria-label={ariaLabel}
    className={cn(
      "relative inline-flex size-9 cursor-pointer items-center justify-center rounded-full",
      HEADER_BUTTON_STATE_CLASSES
    )}
  >
    {icon}
    {count > 0 && (
      <span
        className={cn(
          `
            absolute -top-2 -right-1 flex h-5 items-center justify-center rounded-full bg-white
            text-[12px] leading-[14px] font-semibold text-forest-green-950
          `,
          count > 9 ? "min-w-5 px-2" : "w-5"
        )}
      >
        {count}
      </span>
    )}
  </button>
);
